import React from 'react';
import { IconX } from '@tabler/icons-react';

export interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
    size?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
}

const Modal: React.FC<ModalProps> = ({
    isOpen,
    onClose,
    title,
    children,
    size = 'md',
    className = ''
}) => {
    if (!isOpen) return null;

    const sizeClasses = {
        sm: 'max-w-sm sm:max-w-md',
        md: 'max-w-md sm:max-w-lg',
        lg: 'max-w-lg sm:max-w-2xl',
        xl: 'max-w-xl sm:max-w-4xl'
    };

    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 p-0 sm:p-4"
            onClick={handleBackdropClick}
        >
            <div className={`
                bg-white rounded-t-lg sm:rounded-lg shadow-lg w-full 
                max-h-[95vh] sm:max-h-[90vh] overflow-y-auto
                ${sizeClasses[size]} 
                ${className}
            `}>
                {title && (
                    <div className="flex justify-between items-center p-4 sm:p-6 border-b border-gray-200 sticky top-0 bg-white">
                        <h2 className="text-lg sm:text-xl font-semibold text-gray-900 truncate pr-4">{title}</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600 transition-colors duration-150 p-1 rounded-md hover:bg-gray-100"
                        >
                            <IconX size={20} />
                        </button>
                    </div>
                )}
                <div className={`p-4 sm:p-6 ${title ? '' : 'pt-4 sm:pt-6'}`}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;
